"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactApollo = require("react-apollo");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonI18n = require("@mmc/common-i18n");

var _tableCompare = _interopRequireDefault(require("../styles/table-compare.css"));

var _getCompareModels = require("../graphql/get-compare-models.query");

var _compareSelectBoxes = _interopRequireDefault(require("./compare-select-boxes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var getCmsPath = function getCmsPath(routePathMapping, pathname) {
  var correctPath = '';
  Object.keys(routePathMapping).forEach(function (key) {
    if (key === pathname) {
      correctPath = key;
    }
  });
  return routePathMapping[correctPath];
};

var getQueryParams = function getQueryParams(_ref) {
  var market = _ref.market,
      language = _ref.language,
      path = _ref.path;
  return {
    market: market,
    language: language,
    path: path
  };
}; // const hasSelectedModels = _models => _models && _models.length > 0;


var hasModels = function hasModels(_data) {
  return _data && _data.length > 0;
};

var refineQueryParams = function refineQueryParams(code, year, params) {
  return _objectSpread(_objectSpread({}, params), {}, {
    selection: _objectSpread(_objectSpread({}, params.selection), {}, {
      vehicle: code,
      year: year
    })
  });
};

var ModelSelectorComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ModelSelectorComponent, _React$Component);

  function ModelSelectorComponent(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var numberOfColumns = _this.props.numberOfColumns;
    var initialArray = [];

    for (var i = 0; i < numberOfColumns; i++) {
      initialArray[i] = '';
    }

    _this.state = {
      dropdownUpdate: false,
      selectedCar: initialArray,
      selectedIndex: null,
      initialRun: true
    };
    _this.preSelector = _this.preSelector.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateSelected = _this.updateSelected.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ModelSelectorComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        actions = _this$props.actions,
        data = _this$props.data;
    actions.getAllModels(data.getCompareModels.models);
    actions.getAllSpecificationGroups(data.getCompareModels.specificationGroup);
    actions.getAllSubSpecificationGroups(data.getCompareModels.subSpecificationGroup);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        selectedVehicle = _this$props2.selectedVehicle,
        selectedYear = _this$props2.selectedYear,
        actions = _this$props2.actions,
        data = _this$props2.data,
        models = _this$props2.models;
    var _this$state = this.state,
        initialRun = _this$state.initialRun,
        dropdownUpdate = _this$state.dropdownUpdate,
        selectedCar = _this$state.selectedCar,
        selectedIndex = _this$state.selectedIndex; // Car type change

    if (prevProps.selectedVehicle !== selectedVehicle || prevProps.selectedYear !== selectedYear) {
      actions.getAllModels(data.getCompareModels.models);
      actions.getAllSpecificationGroups(data.getCompareModels.specificationGroup);
      actions.getAllSubSpecificationGroups(data.getCompareModels.subSpecificationGroup);
      this.setState({
        initialRun: true
      });
    } // Initial run - select first three


    if (initialRun) {
      this.preSelector();
    } // After dropdown update


    if (dropdownUpdate) {
      actions.getAllModels(models);
      actions.getAllSpecificationGroups(data.getCompareModels.specificationGroup);
      actions.getAllSubSpecificationGroups(data.getCompareModels.subSpecificationGroup);
      actions.selectModel(selectedCar[selectedIndex], selectedIndex);
      this.setState({
        dropdownUpdate: false,
        selectedIndex: null
      });
    }
  };

  _proto.getModelByCode = function getModelByCode(code) {
    var models = this.props.models;
    var returnObj = null;

    for (var index in models) {
      var model = models[index];

      if (code === model.code) {
        returnObj = model;
        break;
      }
    }

    return returnObj;
  };

  _proto.updateSelected = function updateSelected(model) {
    var selectedCar = this.state.selectedCar;
    var actions = this.props.actions;
    var index = parseInt(model.order, 10);
    var tempHolder = selectedCar;
    if (tempHolder[index] !== '') actions.deselectModel(tempHolder[index], null);
    tempHolder[index] = model.code;
    this.setState({
      dropdownUpdate: true,
      selectedCar: tempHolder,
      selectedIndex: index
    });
  };

  _proto.preSelector = function preSelector() {
    var _this$props3 = this.props,
        models = _this$props3.models,
        numberOfColumns = _this$props3.numberOfColumns,
        actions = _this$props3.actions;
    var selectLength = models.length > 2 ? numberOfColumns : models.length;
    var initialSelectArray = [];

    for (var i = 0; i < selectLength; i++) {
      initialSelectArray[i] = models[i].code;
      models[i].order = i;
      actions.selectModel(models[i].code, i);
    }

    this.setState({
      selectedCar: initialSelectArray,
      initialRun: false
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        models = _this$props4.models,
        theme = _this$props4.theme,
        config = _this$props4.config;
    var selectedCar = this.state.selectedCar;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: Math.random(),
      className: _tableCompare["default"].modelSelectorContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _tableCompare["default"].noMargin + " " + _tableCompare["default"].forceWidth
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-1'] + " " + _tableCompare["default"].noPadding
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-10'] + " " + _tableCompare["default"].noPadding + " " + _tableCompare["default"].forceWidth
    }, hasModels(models) && /*#__PURE__*/_react["default"].createElement("div", {
      key: Math.random(),
      className: _tableCompare["default"].fieldsContainer
    }, selectedCar.map(function (carCode, i) {
      var model = _this2.getModelByCode(carCode);

      var priceValue = handleNestedProp(model, 'model.price.value');
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: Math.random(),
        className: _tableCompare["default"].fieldsSection
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].dropdownPart
      }, /*#__PURE__*/_react["default"].createElement(_compareSelectBoxes["default"], {
        models: models,
        theme: theme,
        order: i,
        selectedValue: carCode,
        updateSelected: _this2.updateSelected
      })), priceValue !== ' ' && priceValue > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableCompare["default"].pricePart
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _tableCompare["default"].dropPrice
      }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
        format: "price",
        options: {
          value: priceValue,
          currency: handleNestedProp(config, 'config.currencyFormat'),
          locale: handleNestedProp(config, 'config.localeCode'),
          displayValue: handleNestedProp(model, 'model.price.displayValue')
        }
      }))));
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-sm-1'] + " " + _tableCompare["default"].noPadding
    })));
  };

  return ModelSelectorComponent;
}(_react["default"].Component);

var ModelSelector = function ModelSelector(_ref2) {
  var actions = _ref2.actions,
      models = _ref2.models,
      config = _ref2.config,
      selectedVehicle = _ref2.selectedVehicle,
      selectedYear = _ref2.selectedYear,
      theme = _ref2.theme,
      routePathMapping = _ref2.routePathMapping,
      currentPath = _ref2.currentPath,
      numberOfColumns = _ref2.numberOfColumns;

  if (selectedVehicle) {
    var correctPath = getCmsPath(routePathMapping, currentPath);
    var QUERY_PARAMS = getQueryParams({
      market: config.market,
      language: config.language,
      path: correctPath
    });
    QUERY_PARAMS = refineQueryParams(selectedVehicle, selectedYear, QUERY_PARAMS);
    return /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: _getCompareModels.GET_COMPARE_MODELS_QUERY,
      variables: QUERY_PARAMS
    }, function (_ref3) {
      var loading = _ref3.loading,
          data = _ref3.data;

      if (loading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _tableCompare["default"].loader + " " + (loading && _tableCompare["default"].isLoading)
        });
      }

      return /*#__PURE__*/_react["default"].createElement(ModelSelectorComponent, {
        config: config,
        data: data,
        actions: actions,
        selectedVehicle: selectedVehicle,
        selectedYear: selectedYear,
        models: models,
        theme: theme,
        numberOfColumns: numberOfColumns
      });
    });
  }

  return null;
};

var _default = ModelSelector;
exports["default"] = _default;